export const parseUrl = (search) => {
  const queries = new URLSearchParams(search);
  const query = Object.fromEntries(queries.entries());
  return query;
};

export const setUrl = (query) => {
  const queries = Object.entries({
    ...query,
  }).reduce((p, [k, v]) => ({ ...p, ...(v ? { [k]: v } : {}) }), {});
  window.history.replaceState(
    {},
    "",
    `?${new URLSearchParams(queries).toString()}`,
  );
};

export const setModalParams = (modalParam, idParam, { type, id } = {}) => {
  const params = new URLSearchParams(window.location.search);
  params.set(modalParam, type || "true");
  if (idParam && id) params.set(idParam, id);
  window.history.replaceState({}, "", `?${params.toString()}`);
};

export const clearModalParams = (modalParam, idParam) => {
  const params = new URLSearchParams(window.location.search);
  params.delete(modalParam);
  if (idParam) params.delete(idParam);
  window.history.replaceState({}, "", `?${params.toString()}`);
};
